import { render } from "./prjCard.vue?vue&type=template&id=324e02af&scoped=true"
import script from "./prjCard.vue?vue&type=script&lang=js"
export * from "./prjCard.vue?vue&type=script&lang=js"

import "./prjCard.vue?vue&type=style&index=0&id=324e02af&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324e02af"]])

export default __exports__